import DioramaPanel from "../../lib/services/scene/diorama_panel";
import ShaderService from "../../lib/services/shader/shader_service";
import Camera from "../../lib/services/scene/camera";
import ResourceService from "../../lib/services/resource/resourceservice";
import BoxCollisionVolume from "../../lib/services/collision/box_collision_volume";
import Stage from "../../lib/services/stage/stage";

export default class Treehouse extends DioramaPanel 
{
   
  constructor(key: string) 
  {
    super(key,"unlit_texture_alpha","treehouse",1,2);

  
      this.transform.set_position(-1.4437795877456665,-0.09163983911275864,-4.067316055297852);
       this.transform.set_rotation(0, 0, 0);
       this.transform.set_scale(1.1726512908935547,1.1726512908935547,1.1726512908935547);
       this.transform.update_matrix();
   
    const cbox = new BoxCollisionVolume(
            0.934,1.350,0.770,   // width, height, depth
           -0.047,0.772,-0.368,   // offset x, y, z
            "nav",
            false
          );
     this.add_collision_volume(cbox);
  }

  async build(device: GPUDevice,format: GPUTextureFormat, shader_service: ShaderService,resource_service: ResourceService): Promise<void> 
  {
       await super.build(device,format,shader_service,resource_service);
       this.register_collisions(Stage.instance().collision_service);

       
 }    
  
  tick(delta_time: number): void 
  {
    // this.placement.tick(delta_time);
    // this.volume_placement.tick(delta_time,0);
     
  }

  prepare(device: GPUDevice, camera: Camera): void 
  {
     super.prepare(device,camera);
     
  }
  
  draw(pass: GPURenderPassEncoder): void 
  {
      super.draw(pass);
  }
   
}